import store from 'storejs';
import { writable } from 'svelte/store';
export const persistStore = (key, initial) => {
	const persist = store.get(key);
	const data = persist ? persist : initial;
	const _store = writable(data, () => {
		const unsubscribe = _store.subscribe((value) => {
			store.set(key, value);
		});
		return unsubscribe;
	});
	return _store;
};
